/**
 * 历史组布局数字常量（无业务 import）。
 * 供 layout-constants / canvas-node-focus 使用，避免与 canvas-reference-flow 形成循环依赖。
 */

/**
 * 历史叶子含 CanvasNodeHeader（普通流首元素）：标题行 22px + mb-2 8px。
 * 取真实占位高度，使成员包围盒 = 叶子可视盒，组框四边留白才等于组内 padding。
 */
export const HISTORY_MEMBER_HEADER_ALLOWANCE = 30;

/**
 * 图片方案区 ↔ 视频区跨区最小垂直间距（骨架与展开历史后的行间避让共用）。
 */
export const HISTORY_ARRANGE_CROSS_ZONE_GAP = 280;
